import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { mockPRs } from '../data/mockData';
import { RFQPanel } from '../components/procurement/RFQPanel';
import { StatusBadge } from '../components/StatusBadge';
export function RFQAction() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const pr = mockPRs.find(p => p.id === id);
  if (!pr) {
    return <div className="flex flex-col items-center justify-center h-full" data-id="element-2335">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-2336">PR not found</h2>
        <button onClick={() => navigate('/rfq')} className="mt-4 text-indigo-600 hover:text-indigo-800" data-id="element-2337">
          Back to RFQ List
        </button>
      </div>;
  }
  return <div className="max-w-6xl mx-auto space-y-6 pb-12" data-id="element-2338">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2339">
        <div className="flex items-center space-x-4" data-id="element-2340">
          <button onClick={() => navigate('/rfq')} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-2341">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-2342" />
          </button>
          <div data-id="element-2343">
            <div className="flex items-center space-x-3" data-id="element-2344">
              <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-2345">
                Process RFQ
              </h1>
              <StatusBadge status="Draft" data-id="element-2346" />
            </div>
            <p className="text-sm text-gray-500 mt-1" data-id="element-2347">
              Request for Quotation for {pr.prNo}
            </p>
          </div>
        </div>
      </div>

      {/* PR Context Card */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-wrap gap-6" data-id="element-2348">
        <div data-id="element-2349">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2350">
            PR Number
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2351">{pr.prNo}</p>
        </div>
        <div data-id="element-2352">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2353">
            Originator
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2354">
            {pr.originator}
          </p>
        </div>
        <div data-id="element-2355">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2356">
            Method
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2357">
            {pr.procurementMethod}
          </p>
        </div>
        <div data-id="element-2358">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2359">
            Total Amount
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-2360">
            ${pr.total.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Embedded Panel */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-2361">
        <RFQPanel data-id="element-2362" />
      </div>
    </div>;
}